import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IPayCategory } from '../../pay-categories.type';

/**
 * Handles display of dump card
 */
@Component({
	selector: 'app-details-card',
	templateUrl: './details-card.component.html'
})
export class DetailsCardComponent implements OnInit {
	@Output() public onChange: EventEmitter<IPayCategory> = new EventEmitter();
	@Input() public payCategory: IPayCategory;
	@Input() public isArchived: boolean;

	public ngOnInit(): void {
		if (!this.payCategory) {
			return;
		}
	}

	public isNeedChange(): void {
		this.onChange.emit(this.payCategory);
	}
}
